import React from 'react';
import {
  Handshake,
  Maximize2,
  Users,
  Gift,
  Building2,
  Coffee,
  GraduationCap,
  ArrowRight
} from 'lucide-react';

const IDEAL_SPACES = [
  { icon: <Users className="w-5 h-5" />, label: 'Meeting / Conference Rooms' },
  { icon: <Building2 className="w-5 h-5" />, label: 'Workspaces & Offices' },
  { icon: <Coffee className="w-5 h-5" />, label: 'Cafes, Studios & Co-working Spaces' },
  { icon: <GraduationCap className="w-5 h-5" />, label: 'Educational or Training Rooms' },
];

export const PilotPartners = () => (
  <section className="py-20 px-6 bg-[#4A5D4E] text-white">
    <div className="container mx-auto max-w-6xl">
      {/* Header */}
      <div className="text-center mb-14">
        <Handshake className="w-12 h-12 mx-auto mb-4 text-[#D4A574]" />
        <h2 className="text-4xl font-bold mb-4">
          We're Looking for Pilot Partners
        </h2>
        <p className="text-lg text-white/80 max-w-2xl mx-auto">
          Help us validate our bio-materials in real-world settings. 
          Be among the first to experience sustainable acoustic panels and construction materials.
        </p>
      </div>

      {/* Three columns */}
      <div className="grid md:grid-cols-3 gap-8 mb-14">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
          <Maximize2 className="w-8 h-8 text-[#D4A574] mb-4" />
          <h3 className="text-xl font-bold mb-3">What We Need</h3>
          <p className="text-white/80">
            ~25 sq ft of mockup space (wall or ceiling) in your facility to install and test our panels.
          </p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
          <Users className="w-8 h-8 text-[#D4A574] mb-4" />
          <h3 className="text-xl font-bold mb-3">What You'll Help Us Do</h3>
          <ul className="text-white/80 space-y-2">
            <li>Test product performance in real conditions</li>
            <li>Gather acoustic feedback & user experience</li>
          </ul>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
          <Gift className="w-8 h-8 text-[#D4A574] mb-4" />
          <h3 className="text-xl font-bold mb-3">What You Get</h3>
          <ul className="text-white/80 space-y-2">
            <li>Early access to our sustainable panels</li>
            <li>Brand visibility as a sustainability leader</li>
            <li>Co-create the future of green materials</li>
            <li>Contribute to innovation with real-world impact</li>
          </ul>
        </div>
      </div>

      {/* Ideal Spaces */}
      <div className="bg-white/5 border border-white/10 rounded-xl p-8 mb-12">
        <h3 className="text-lg font-bold text-[#D4A574] mb-6 text-center">Ideal Spaces for Pilot</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {IDEAL_SPACES.map((item) => (
            <div key={item.label} className="flex items-center gap-3 bg-white/10 rounded-lg p-4">
              <span className="text-[#A8C9A5] flex-shrink-0">{item.icon}</span>
              <span className="text-sm text-white/90">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Button */}
      <div className="text-center">
        <a href="/contact">
          <button className="bg-[#D4A574] hover:bg-[#C09460] text-white px-10 py-4 rounded-lg font-semibold text-lg transition-colors">
            Partner With Us
            <ArrowRight className="inline ml-2 w-5 h-5" />
          </button>
        </a>
      </div>
    </div>
  </section>
);
